import Interweave from 'interweave'
import { isEmpty } from 'lodash-es'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { convertMdToHtml } from '..'
import { AUDIT_TYPE } from '../../../constants'
import Link from '../../Link'
import Section from '../../Section'

const StepsList = styled.div`
  span {
    ul:first-of-type {
      padding-inline-start: 25px;
    }
  }

  li {
    margin-bottom: 8px;
  }
`

const Toolset = ({ report: { auditType, reportContent } }) => {
  const isNormalAudit = auditType === AUDIT_TYPE.NORMAL || !auditType

  return (
    <Section title="Toolset">
      <p>
        The notes below outline the setup and steps performed in the process of this{' '}
        {isNormalAudit ? 'audit' : 'security review'}.
      </p>
      <div>
        <h4>Setup</h4>
        <p>Tool Setup:</p>
        <ul>
          {reportContent.breakdownAndAutomatedAnalysis.tools.map((tool, index) => (
            <li key={index}>
              {isEmpty(tool.url) ? (
                tool.name.label
              ) : (
                <>
                  <Link href={tool.url} target="_blank" rel="noreferrer">
                    {tool.name.label}
                  </Link>
                  &nbsp;&nbsp;{tool.version}
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
      <StepsList>
        <p>Steps taken to run the tools:</p>
        <br></br>
        {reportContent.breakdownAndAutomatedAnalysis.tools.map((tool, key) => (
          <>
            <h5>{tool.name.label}</h5>
            <Interweave
              key={key}
              content={tool.steps ? convertMdToHtml.makeHtml(tool.steps) : null}
            />
            <br></br>
          </>
        ))}
      </StepsList>
    </Section>
  )
}

Toolset.propTypes = {
  report: PropTypes.object,
}

export default Toolset
